import { isDateCurrentYear } from '../validator/is-date-current-year'
import { isDateToday } from '../validator/is-date-today'

/**
 * Formats a given ISO-8601 compliant string into a human readable format. You can configure this function to
 * omit the current year or the whole date if the given date is today.
 *
 * To keep the function performant there is no type checking like 'date instanceof Date' or 'moment(date).isValid()'.
 * If you aren't sure about the arguments you pass to this function please validate them beforehand.
 *
 * @param {Intl} intl                   - The global Modux intl helper.
 * @param {string} iso8601string        - The date to be parsed as ISO-8601 compliant string with time zone.
 * @param {boolean} hideDateIfToday     - Hides the date component (YYYY-MM-DD) if the given ISO-8601 compliant string
 *                                        states today.
 * @param {boolean} hideYearIfCurrent   - Hides the year if the given ISO-8601 compliant string states the current year.
 * @returns {string|null}
 */
export function formatIso8601String(intl, iso8601string, hideDateIfToday = false, hideYearIfCurrent = false) {
    if (!iso8601string || isNaN(new Date(iso8601string).getTime())) {
        return null
    }

    const date = new Date(iso8601string)

    if (hideDateIfToday && isDateToday(date)) {
        return intl.formatTimeOnly(date)
    } else {
        const formatString = hideYearIfCurrent && isDateCurrentYear(date) ? 'shortDateTimeWoYear' : 'shortDateTime'
        return intl.formatDate(date, formatString)
    }
}
